module.exports = __webpack_public_path__ + "img/icon_map_sdcy.6c49109d.png";